module.exports = __webpack_public_path__ + "img/module.07d81858.png";